
// Project Imports
import { MOBILE_NO_VALIDATION, PAN_NUMBER_REGEX, CHARACTER_REGEX, NUMBER_REGEX } from "constants/Constants";
import CustomerTypeConstant from "constants/CustomerTypeConstant";

const FormObserver = (formRef) => {

  formRef.$('category').observe({
    key: 'value',
    call: ({ field }) => {
      formRef.$("employee_code").value = '';
      //formRef.$("education").value = {};
      //formRef.$("occupation").value = {};
    }
  })

  formRef.$('customer_type').observe({
    key: 'value',
    call: ({ field, form }) => {

    }
  })

  formRef.$('existing_customer_type_option_list').observe({
    key: 'value',
    call: ({ field, form }) => {
      let currentValue = field.value.id
      let placeholderValue = "";

      let dataType = "text"

      switch (currentValue) {
        case 'policy_number':
          placeholderValue = "Enter Policy Number"
          formRef.$("dob").set('extra', { showDOB: true ,})
          formRef.$("dob").set('value', "")
          break

        case 'mobile_number':
          placeholderValue = "Enter Mobile Number"
          dataType = "number"
          formRef.$("dob").set('extra', { showDOB: true })
          break

        case 'pan_number':
          placeholderValue = "Enter PAN Number"
          formRef.$("dob").set('extra', { showDOB: false })
          break

        case 'customer_id':
          placeholderValue = "Enter Customer ID"
          formRef.$("dob").set('extra', { showDOB: false })
          formRef.$("dob").set('value', "")
          break

      }
      form.$("existing_customer_type_option_list").set("type", dataType)
      form.$("existing_customer_type_option_list").set("placeholder", placeholderValue)
      formRef.$("existing_customer_value").value = '';
      formRef.$("existing_customer_value").validate()
      formRef.$("dob").validate()
    }
  })

  formRef.$('existing_customer_value').observe({
    key: 'value',
    call: ({ field, form }) => {

      let selectedOption = formRef.$('existing_customer_type_option_list').value.id

      let currentValue = field.value.toUpperCase();

      switch (selectedOption) {

        case "mobile_number": // ! FOR MOBILE NO VALIDATION

          const mobileNoValue = currentValue.replace(/[^0-9 ]/g, "")

          if ((!MOBILE_NO_VALIDATION.test(mobileNoValue) && currentValue.length <= 10)) {
            formRef.$("existing_customer_value").set('value', mobileNoValue)
          } else if (currentValue.length > 10) {
            const value = currentValue.slice(0, 10)
            formRef.$("existing_customer_value").set('value', value)
          }

          break

        case "customer_id":
          formRef.$("existing_customer_value").set('value', currentValue.replace(/[^a-zA-Z0-9 ]/g, ""))
          break

        case "policy_number":
          formRef.$("existing_customer_value").set('value', currentValue.replace(/[^a-zA-Z0-9 ]/g, ""))
          break

        case "pan_number": // ! FOR PAN NO VALIDATION
          formRef.$("existing_customer_value").set('value', currentValue.replace(/[^a-zA-Z0-9 ]/g, ""))

          if (currentValue.length > 10) {
            const value = currentValue.slice(0, 10)
            formRef.$("existing_customer_value").set('value', value)
          }

          if ((PAN_NUMBER_REGEX.test(currentValue))) {
            formRef.$("existing_customer_value").set('value', currentValue)
            // formRef.$("existing_customer_value").invalidate('Please enter a valid Pan Number')
          }

          // if (currentValue.length <= 5 && !(CHARACTER_REGEX.test(currentValue))) {
          //   const value = currentValue.slice(0, -1)
          //   formRef.$("existing_customer_value").set('value', value)
          // }

          // if ((currentValue.length > 5 && currentValue.length < 10) && !(NUMBER_REGEX.test(currentValue.slice(-1)))) {
          //   const value = currentValue.slice(0, -1)
          //   formRef.$("existing_customer_value").set('value', value)
          // }

          // if (currentValue.length == 10 && !(CHARACTER_REGEX.test(currentValue.slice(-1)))) {
          //   const value = currentValue.slice(0, -1)
          //   formRef.$("existing_customer_value").set('value', value)
          // }

          // ABCTY1234D
          // 1234567890

          break;

        default:
          break;
      }

    }
  })

}

export default FormObserver